import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Space,
} from '@tonic-one/react';
import { t } from 'i18next';
import { useState } from 'react';

import LoadingBtn from '../LoadingBtn';

/**
 * @deprecated Use "@Components/Common/ActionModal" instead of this
 */
export default function ActionModal(props: any) {
  const {
    visible,
    onClose,
    onConfirm,
    loading = false,
    title,
    disabled = false,
    confirmText = t('reportCommon.buttons.save'), // default value
    cancelText = t('reportCommon.buttons.cancel'), // default value
    children,
  } = props;

  const useToggle = (defaultValue: boolean) => {
    const [value, setValue] = useState(defaultValue);
    const toggle = () => setValue((value) => !value);
    return [value, toggle];
  };

  const [isOverlayVisible] = useToggle(true);

  return (
    <Modal
      ensureFocus={true}
      autoFocus={false}
      closeOnEsc={true}
      closeOnOutsideClick={false}
      isClosable={true}
      isOpen={visible}
      onClose={onClose}
      size="md"
    >
      {isOverlayVisible && <ModalOverlay opacity={0.9} />}
      <ModalContent>
        <ModalHeader>{title || t('reportCommon.titles.title')}</ModalHeader>
        <ModalBody>{children}</ModalBody>
        <ModalFooter>
          <LoadingBtn
            variant="primary"
            minWidth="20x"
            loading={loading}
            onClick={onConfirm}
            disabled={disabled}
          >
            {confirmText}
          </LoadingBtn>
          <Space width="2x" />
          <Button minWidth="20x" onClick={onClose}>
            {cancelText}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
